module.exports = __webpack_public_path__ + "img/mobile-single-android.a8e360d2.svg";